import React, { FC } from 'react';
import { Box, Typography, TableCell, TableRow } from '@dxb-web-ui-framework/design-system';

export interface NoResultsFoundRowProps {
  colSpan?: number;
  noResultsMsg: string;
}

const NoResultsFoundRow: FC<NoResultsFoundRowProps> = ({ colSpan, noResultsMsg }) => (
  <TableRow>
    <TableCell colSpan={colSpan}>
      <Box px={2} py={2} display={'flex'} justifyContent={'center'}>
        <Typography variant={'body1'}>{noResultsMsg}</Typography>
      </Box>
    </TableCell>
  </TableRow>
);

export { NoResultsFoundRow };
